// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MemberSvg from '@rsuite/icon-font/lib/people/Member';
var Member = createSvgIcon({
  as: MemberSvg,
  ariaLabel: 'member',
  category: 'people',
  displayName: 'Member'
});
export default Member;